import { memo } from 'react';
import { useTour } from '@reactour/tour';
import { twMerge } from 'tailwind-merge';
import CloseIcon from '@mui/icons-material/Close';
export const OnboardingStep = memo(({ children, disableArrows, disableDots, disableNext }) => {
    var _a;
    const tour = useTour();
    if (disableArrows && disableDots) {
        return <>{children}</>;
    }
    return (<div className="flex flex-col gap-4">
			{children}
			<button type="button" onClick={() => tour.setIsOpen(false)} className="absolute -top-2 -right-2 shadow size-8 rounded-full bg-white">
				<CloseIcon />
			</button>
			<div className="flex justify-between items-center">
				{!disableDots && (<ul className={twMerge('flex gap-1.5', disableArrows && 'justify-center')}>
						{(_a = tour === null || tour === void 0 ? void 0 : tour.steps) === null || _a === void 0 ? void 0 : _a.map((_, stepIndex) => {
                const isFilled = stepIndex <= tour.currentStep;
                return (<li 
                /* eslint-disable-next-line react/no-array-index-key */
                key={stepIndex.toString()} className={twMerge('size-3 rounded-full bg-[#3898FC] opacity-50 border-2 border-white', isFilled && 'bg-primary animate-pop-up opacity-100 border-gray-200')}/>);
            })}
					</ul>)}
				{!disableArrows && (<div className="flex self-end justify-end gap-2">
						<button type="button" onClick={() => tour.setCurrentStep(prev => (prev > 0 ? prev - 1 : prev))} className="rounded text-xs font-inter border-t-2 border-transparent p-2 opacity-50 text-black">
							Back
						</button>
						{!disableNext && (<OnboardingPrimaryButton onClick={() => tour.setCurrentStep(prev => (prev < tour.steps.length - 1 ? prev + 1 : prev))}>
								Continue
							</OnboardingPrimaryButton>)}
					</div>)}
			</div>
		</div>);
});
export const OnboardingPrimaryButton = memo((props) => {
    return (<button type="button" className="bg-primary rounded-lg font-inter border-t-2 border-accent text-xs px-3 py-1 font-medium" {...props}/>);
});
